<template lang="pug">
    a(v-if="path || href" :href="finalLink" :target="target")
      .box
        h3.title {{panel.title}} 
</template>

<script>
import { get, startsWith } from '@/helpers';

export default {
    name: 'Panel',
    mounted() {
        if (this.id) {
            const state = this.getCollapseState();
            if (state) {
                this.isCollapsed = state[this.id];
            }
        }
    },
    props: {
        panel: {
            type: Object,
            required: true
        },
        index: {
            type: Number,
            required: true
        }
    },
    computed: {
        hyperlink() {
            return get(this.panel, 'hyperlink') || {};
        },
        href() {
            let href = false;

            if (this.hyperlink.type !== 'internal' && get(this.hyperlink, 'href')) {
                const link = this.hyperlink.href;
                switch (this.hyperlink.type) {
                    case 'external':
                        if (!startsWith(link, 'https://') && !startsWith(link, 'http://')) href = `https://${link}`;
                        else href = link;
                        break;

                    case 'mailto':
                        href = `mailto:${link}`;
                        break;

                    case 'tel':
                        href = `tel:${link}`;
                        break;
                }
            }

            return href;
        },
        target() {
            return get(this.hyperlink, 'target') || '_self';
        },
        path() {
            if (this.hyperlink.type === 'internal' && get(this.hyperlink, 'menuItem.path'))
                return this.hyperlink.menuItem.path;
            else return false;
        },
        finalLink() {
            if (this.path) {
                return this.path;
            } else if (this.href) {
                return this.href;
            } else {
                return false;
            }
        }
    }
};
</script>

<style lang="sass" scoped>
@import "~@/assets/sass/variables"

.box
  @apply transition-transform duration-300 ease-in-out rounded-full flex mx-2 items-center justify-center uppercase font-semibold text-white text-xl
  background-color: $cc-green
  width: 100px
  height: 100px

  @screen md
    @apply h-48 w-48 mx-8 text-2xl

  @screen lg
    @apply h-56 w-56 text-3xl

  &:hover
    @apply transform scale-105
</style>
